import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

import { casingPostProcessor } from './casingPostProcessor';
import { resolveLanguages } from './languages';
import namespaces, { NS_COMMON } from './namespaces';

const isDevelopment = process.env.NODE_ENV === 'development';
const defaultLanguage = 'en';

async function initializeAndUseI18n(appInfo) {
  const { localizingEnabled, notUsInstance } = appInfo.features;

  return await i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .use(casingPostProcessor)
    .init({
      fallbackLng: defaultLanguage,
      supportedLngs: localizingEnabled ? Object.keys(resolveLanguages(notUsInstance)) : defaultLanguage,
      ns: namespaces,
      debug: false,
      defaultNS: NS_COMMON,
      interpolation: {
        escapeValue: false
      },
      postProcess: [casingPostProcessor.name],
      react: {
        transKeepBasicHtmlNodesFor: ['strong', 'br', 'b', 'i', 'p', 'ul', 'li', 'u']
      },
      backend: {
        loadPath: `/locales/{{lng}}/{{ns}}.json?v=${appInfo.displayAppVersion}`,
        allowMultiLoading: false,
        crossDomain: false,
        requestOptions: isDevelopment
          ? {
              cache: 'no-store',
              headers: {
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cache',
                Expires: '0'
              }
            }
          : {
              cache: 'default',
              headers: {
                'Cache-Control': 'max-age=31536000'
              }
            }
      },
      detection: {
        order: ['localStorage', 'navigator'],
        caches: ['localStorage']
      }
    });
}

export default initializeAndUseI18n;
